export default __webpack_public_path__ + "assets/icons/e-mail.33327345.svg";